import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const apiV3EmailPrefix = `/api/v3/email`;

@Injectable({ providedIn: 'root' })
export class EmailBackend {
  v3 = {
    getEmailCategories: () => this.http.get(`${apiV3EmailPrefix}/categories`),
    deleteEmailUnsubscribe: (emails: string[]) =>
      this.http.delete(`${apiV3EmailPrefix}/unsubscribe`, {
        params: { emails },
      }),
    getEmailUnsubscribe: (email: string) =>
      this.http.get(`${apiV3EmailPrefix}/unsubscribe`, { params: { email } }),
    postEmailUnsubscribe: (emails: string[]) =>
      this.http.post(`${apiV3EmailPrefix}/unsubscribe`, { emails }),
  };

  constructor(private http: HttpClient) {}
}
